// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageCoverFragmentDoc } from '../imageCover.fragment.generated';
import { ImageLargeFragmentDoc } from '../imageLarge.fragment.generated';
import { ContentComponentItemFragmentDoc } from './ContentComponentItem.fragment.generated';
import { VideoFragmentDoc } from '../video.fragment.generated';
export const ComponentMainCoverFragmentDoc = gql`
    fragment componentMainCover on ComponentMainCover {
  mainCoverImage: backgroundImage {
    ...imageCover
  }
  mobileBackgroundImage {
    ...imageLarge
  }
  content {
    ...contentComponentItem
  }
  height
  overlay
  contentWidth: width
  background {
    __typename
    ... on ComponentMainCoverBackgroundImage {
      backgroundImage {
        ...imageCover
      }
      mobileBackgroundImage {
        ...imageLarge
      }
    }
    ... on ComponentMainCoverBackgroundVideo {
      video {
        ...video
      }
      cover {
        ...imageCover
      }
      mobileCover {
        ...imageLarge
      }
    }
  }
}
    ${ImageCoverFragmentDoc}
${ImageLargeFragmentDoc}
${ContentComponentItemFragmentDoc}
${VideoFragmentDoc}`;